import React from 'react';
import { AutoCompleteProps as $AutoCompleteProps } from 'antd/lib/auto-complete';

import { AutoComplete as $AutoComplete } from '../components/common/antd/antd-override';

export type AutoCompleteProps = $AutoCompleteProps;
export default function AutoComplete({ children, ...props }: AutoCompleteProps) {
  return <$AutoComplete {...props}>{children}</$AutoComplete>;
}
